
import React, { useEffect, useRef } from 'react';
import MessageInfo from '../../common/MessageInfo';
import { labels } from '../../data/labels';
import { useFetchAgendaLiveStreaming } from '../../data/fetchAgendaLiveStreaming';
import { AgendaStreamingContext } from '../../common/AgendaStreamingContextProvider';
import Loader from '../../common/Loader';
import AgendaStreamingSport from './AgendaStreamingSport'
import { LiveContext, StreamingContext } from '../Live';
import LiveSporstNav from '../live-suite/LiveSportsNav';
import { isOverlaySection } from '../../utils/sport-effects';
import { AppContext } from '../../App';
import Streaming from '../Streaming';
import { classIf } from '../../data/utils/classIf';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';

function AgendaStreaming(props) {
    const appContext = React.useContext(AppContext);
    const liveContext = React.useContext(LiveContext);
    const agendaStreamingContext = React.useContext(AgendaStreamingContext);
    const streamingContext = React.useContext(StreamingContext);
    const [state, , isSetInterval] = useFetchAgendaLiveStreaming();
    const sticky = useRef(null);

    function changeSport(sportId) {
        liveContext.openLiveSuite(sportId);
    }

    useEffect(() => {
        return () =>{
            streamingContext.toggleStreamingId(null,null,null);
            agendaStreamingContext.setCurrentMatch(null);
        }
    }, []);

    useEffect(function() {
        try {
            if(sticky.current){
                const header = document.querySelector('.cg-top-header');
                const headerHeight = header?header.getBoundingClientRect().height:0;
                const navSlider =  document.querySelector('.nav-slider-container');
                const navSliderHeight =  navSlider?navSlider.getBoundingClientRect().height:0;
    
                const stickyTop = headerHeight + navSliderHeight;
    
                if(stickyTop){
                    sticky.current.style.top = stickyTop+'px';
                }
    
                sticky.current.style.backgroundColor = '#dadada';
            }
        }catch(err){
            console.log(err);
        }
        
    }, [state.data]);

    useEffect(function() {
        let firstMatch;
        const hasTournaments =  state.data && Object.values(state.data).find(s => s.hasTournaments);
        hasTournaments && Object.values(state.data).forEach(function(asSport) {
            Object.values(asSport.tournamentsById).forEach(function(t) {
                if ((firstMatch || null) === null) {
                    firstMatch =  Object.values(t.matchesById).find(m => !m.strOver);
                }
            });
        });
        agendaStreamingContext.setCurrentMatch(firstMatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[state.data]);

    if ((!isSetInterval && state.isLoading) || state.isError) {
        return <Loader error={state.isError} />;
    }

    function messageInfo() {
        return (
            <>
                <div className="bianco titolo-blocco-sport pointer"></div>
                <MessageInfo message={labels['live_page.streams_schedule.no_matches']} />
            </>
        ) 
    }

    if (!(state.data) || Object.keys(state.data).length === 0) {
        return (
            <>
                {messageInfo()}
            </>
        );
    }

    const hasTournaments =  Object.values(state.data).find(s => {return s.hasTournaments})
    const agendaStreamingSports = hasTournaments && Object.values(state.data).map(function(asSport) {
        return asSport.hasTournaments &&  <AgendaStreamingSport key={asSport.sportId} {...asSport} />;
    });
    const hideWrapper = isOverlaySection(appContext,props.section);
	const icoSport = agendaStreamingContext.currentMatch && iconSportCssClass(agendaStreamingContext.currentMatch.sportRef,agendaStreamingContext.currentMatch.iconClass);
    const icoCategory =  agendaStreamingContext.currentMatch && iconCategoryCssClass(agendaStreamingContext.currentMatch.sportRef, agendaStreamingContext.currentMatch.categoryRef, agendaStreamingContext.currentMatch.iconClassCountry)

    return (
        <>
            <LiveSporstNav sports={liveContext.sports} changeSport={changeSport} />
            <div ref={sticky} className={`sticky liveStreamingMatch ${hideWrapper?'no-scroll d-none':''} `}>
                <div className={`overlay-container`}>
                    <Streaming />
                    {agendaStreamingContext.currentMatch &&
                        <div className="list-element">
                        <div className={"prematch-sport-img big "+ icoSport}></div>
                        <div className={"prematch-sport-img big "+ icoCategory}></div>
                        <span className="list-element-text list-heading push-left">
                            {agendaStreamingContext.currentMatch.team1} - {agendaStreamingContext.currentMatch.team2}
                        </span>
                        <span className="list-element-info">{agendaStreamingContext.currentMatch.date.formatted}</span>
                    </div>
                    }
                </div>
            </div>
            <hr/>
            <div id="main-wrapper" className={"wrapper" + classIf(hideWrapper, 'no-scroll d-none')}>
                <div id="main-container" className="main-content">
                    <div id="avvenimenti">
                        <span className="list-heading">{labels['live_page.streams_schedule.live_feed']}</span>
                        {agendaStreamingSports || 
                            messageInfo()
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default AgendaStreaming;